import React, { useEffect, useState } from 'react';
import { Box, Grid, Tab, Tabs, tabsClasses } from '@mui/material';
import { ArticleTags } from '@/interfaces/community/article';
import { GetAllArticleTag } from '@/api/article';
import { useSelector, useDispatch } from 'react-redux'; // Import useDispatch
import { RootState } from '@/store/store';
import { setTagId } from '@/store/slices/articleActivitySlice'; // Import action

const TabCategoryActivity: React.FC = () => {

    const dispatch = useDispatch();
    const tagId = useSelector((state: RootState) => state.articleActivity.tagId);

    const [category, setCategory] = useState<ArticleTags[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const dataSetCategory = await GetAllArticleTag();
            setCategory(dataSetCategory);
        };

        fetchData();
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        dispatch(setTagId(newValue));
    };

    return (
        <Grid xs={12}>
            <Box
                sx={{
                    flexGrow: 1,
                    maxWidth: "100%",
                    bgcolor: 'background.paper',
                }}
            >
                <Tabs
                    value={tagId}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="arrows tabs article"
                    allowScrollButtonsMobile
                    TabIndicatorProps={{
                        style: { backgroundColor: 'white' }
                    }}
                    sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                        flexWrap: 'nowrap',
                        "& .Mui-selected": {
                            color: '#292929 !important',
                            bgcolor: "#f9dfb9",
                            borderColor: "#ffe0cc",
                        },
                        "& .MuiTabs-flexContainer": {
                            gap: '10px',
                        },
                        "& .css-69z67c-MuiTabs-scroller": {
                            display: "flex",
                            alignItems: 'center'
                        },
                        "& .css-ptiqhd-MuiSvgIcon-root": {
                            border: "1px solid #d5d5d5",
                            px: 0.5,
                            py: 0.5,
                            borderRadius: "50px",
                            fontSize: 20,
                            backgroundColor: "#ffffff"
                        },
                    }}
                >
                    {category?.map((data: ArticleTags) => (
                        <Tab
                            disableRipple
                            key={data.id}
                            label={`#${data.tagTitle}`}
                            sx={{
                                border: '1px solid #dee2e6',
                                borderRadius: '20px',
                                color: "#292929",
                                minHeight: '30px',
                                padding: "5px 16px",
                                fontSize: '14px',
                            }}
                            value={data.id}
                        />
                    ))}
                </Tabs>
            </Box>
        </Grid>
    );
}

export default TabCategoryActivity;
